import { GeniePtColumns } from '../../api/pushGenie';

export const UPDATE_PT_COLUMNS = 'UPDATE_PT_COLUMNS';

export interface UpdatePtColumnsAction {
    type: typeof UPDATE_PT_COLUMNS;
    columns: GeniePtColumns;
}

export const updatePtColumns = (columns: GeniePtColumns): UpdatePtColumnsAction => {
    return { type: UPDATE_PT_COLUMNS, columns };
};

export type GenieActions = UpdatePtColumnsAction;
